import React, {Component} from 'react';
import PropTypes from 'prop-types';

class DeployIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 21 21"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-846.000000, -6542.000000)"
            >
              <g id="Model-Action-Icons" transform="translate(56.000000, 6308.000000)">
                <g id="row" transform="translate(0.000000, 195.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="model-actions-/-deploy-/-Enabled,-Focus"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M8.45754979,15.5280892 C8.7855902,15.8561296 8.7855902,16.3879882 8.45754979,16.7160286 L3.98863494,21.1849434 C3.66059453,21.5129838 3.12873595,21.5129838 2.80069554,21.1849434 C2.47265514,20.856903 2.47265514,20.3250445 2.80069554,19.9970041 L7.2696104,15.5280892 C7.59765081,15.2000488 8.12950939,15.2000488 8.45754979,15.5280892 Z M5.27556928,14.467429 C5.60360968,14.7954694 5.60360968,15.327328 5.27556928,15.6553684 L3.63508155,17.2958561 C3.30704114,17.6238966 2.77518256,17.6238966 2.44714215,17.2958561 C2.11910175,16.9678157 2.11910175,16.4359572 2.44714215,16.1079168 L4.08762989,14.467429 C4.41567029,14.1393886 4.94752887,14.1393886 5.27556928,14.467429 Z M9.51820997,18.7100697 C9.84625037,19.0381101 9.84625037,19.5699687 9.51820997,19.8980091 L7.87772223,21.5384968 C7.54968183,21.8665372 7.01782325,21.8665372 6.68978284,21.5384968 C6.36174244,21.2104564 6.36174244,20.6785978 6.68978284,20.3505574 L8.33027057,18.7100697 C8.65831098,18.3820293 9.19016956,18.3820293 9.51820997,18.7100697 Z M10.0466807,5.76825669 C9.12716718,7.35450712 8.44334632,9.16494119 8.12068169,11.1815951 C8.11844978,11.1955446 8.11623616,11.2094999 8.11404087,11.2234611 L4.92910694,10.5854328 C5.23852727,9.14575263 5.95494179,7.97654907 7.07835051,7.0778221 C7.81980026,6.48466229 8.68387016,6.0735897 9.67056019,5.84460431 L10.0039983,5.77501982 L10.0466807,5.76825669 Z M18.2330508,13.952867 C18.0269931,15.0980559 17.5902183,16.0878329 16.9227263,16.9221979 C16.0239993,18.0456066 14.8545533,18.7617787 13.4143883,19.0707142 L12.7774077,15.8836613 L12.818226,15.8791394 C14.8174131,15.5592695 16.6139372,14.8844723 18.1902971,13.9769798 L18.2330508,13.952867 Z M21.1925629,2.80725819 C21.7582483,3.37294361 23.3138833,7.75700565 19.7783493,11.2925396 C19.7783493,11.2925396 16.2428154,14.8280735 10.3031185,14.8280735 C9.54887124,14.8280735 9.17174763,14.4509498 9.17174763,13.6967026 C9.17174763,7.75700565 12.7072815,4.22147175 12.7072815,4.22147175 C16.2428154,0.685937842 20.6268775,2.24157276 21.1925629,2.80725819 Z M17.3034756,6.69634548 C16.7176892,6.11055904 15.7679417,6.11055904 15.1821553,6.69634548 C14.5963688,7.28213192 14.5963688,8.23187939 15.1821553,8.81766583 C15.7679417,9.40345226 16.7176892,9.40345226 17.3034756,8.81766583 C17.889262,8.23187939 17.889262,7.28213192 17.3034756,6.69634548 Z"
                        id="Shape"
                        fill="currentColor"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

DeployIcon.propTypes = {
  className: PropTypes.string,
};

export default DeployIcon;
